import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import getConfig from 'next/config';

import getRelativePathBasedOnDomain from 'lib/getRelativePathBasedOnDomain';
import { PREVIEW_DISABLE_CLASS } from 'lib/vilynxOptions';

const mapStateToProps = ({ router }) => ({
  domain: router.domain,
  host: router.host,
});

@connect(mapStateToProps)
class Link extends React.Component {
  static propTypes = {
    domain: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
    to: PropTypes.string,
    host: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    to: null,
    host: null,
    className: null,
  };

  // Copy props to attribs without invalid ones
  elementAttribs = () => {
    const {
      publicRuntimeConfig: {
        ENABLE_RELATIVE_LINKS,
      },
    } = getConfig();

    const {
      // eslint-disable-next-line react/prop-types
      dispatch, domain, children, to, href, host, vilynxid, vilynxId, className, deviceUrl,
      ...attribs
    } = this.props;

    const getLinkHref = function getLinkHref() {
      // "to" property was used for SPA
      // consolidate with href now that SPA is deprecated
      const url = to || href || null;
      let relativePath;

      if (ENABLE_RELATIVE_LINKS && !/^(mailto|sms|tel)/i.test(url)) { // eslint-disable-line no-undef
        // use relative paths for environment based testing
        relativePath = getRelativePathBasedOnDomain(url, domain, host);
      }
      return relativePath || url;
    };

    const linkAttributes = {
      href: getLinkHref() || deviceUrl,
      ...attribs,
    };

    return linkAttributes;
  }

  render() {
    const { children, className } = this.props;
    const linkAttributes = this.elementAttribs();

    return (
      <a
        {...linkAttributes}
        className={classNames(className, PREVIEW_DISABLE_CLASS)}
      >
        {children}
      </a>
    );
  }
}

export default Link;
